import React, { useEffect, useState } from 'react'
import { get } from 'lodash'
import { css } from 'glamor'
import glamorous from 'glamorous'

import {
  HeadingText,
  BodyText,
  Dialog,
  Sheet,
  Button,
  LoadingSpinner,
} from '@paypalcorp/pp-react'

import clientData from 'utils/client-data'

// content
import getContent from 'pp-react-l10n'
import { showServiceError } from '../error/util'
import { tracking } from '../../../lib/analytics'
import Events from '../../../lib/analytics/event-tags'
import { phone6PlusPortraitMaxAndSmaller } from '../../../lib/styles/media-queries'
const l10n = getContent('pages/seller/photos')

const DialogContent = glamorous.div(({ isLoadingPhoto = false }) => ({
  ...(isLoadingPhoto && { opacity: '50%' }),
}))

const SpinnerContainer = glamorous.div({
  position: 'absolute',
  left: '50%',
  top: '40%',
  transform: 'translate(-50%,-50%)',
  zIndex: '1',
})

const DialogBodyText = css({
  margin: '43px',
  padding: '0 20px',
  [phone6PlusPortraitMaxAndSmaller]: {
    margin: '20px 0',
    padding: '0',
  },
})

const InitialDialog = props => {
  const { onClose, isOpen, onCancelButton, sellerProfileState } = props

  const [isLoadingPhoto, setIsLoadingPhoto] = useState(false)
  const isMobile = get(clientData, 'isMobile', false)

  useEffect(() => {
    isOpen &&
      tracking(Events.public_identity_profile_photo_create_screen_shown({}))
  }, [isOpen])

  const onHandleCancel = () => {
    tracking(Events.public_identity_profile_photo_create_not_now_pressed({}))
    onCancelButton()
    onClose()
  }

  const onHandleClose = () => {
    onClose()
  }

  const hiddenFileInput = React.useRef(null)

  const onAddPhoto = () => {
    tracking(Events.public_identity_profile_photo_create_add_pressed({}))
    hiddenFileInput.current.click()
    onClose()
  }

  const advanceToProfilePan = () => {
    // TODO: Add instrumentation here
    props.history.push('/seller/photos/profile')
  }

  const onFileSelected = event => {
    setIsLoadingPhoto(true)
    sellerProfileState.processImage(
      {
        scan: true,
      },
      {
        isNewFile: true,
        fileEvent: event,
        mediaCategory: 'PROFILE_IMAGE',
        handleActions: {
          onScan: {
            onSuccess: advanceToProfilePan,
            onError: decisionMsg => {
              props.history.push({
                pathname: '/seller/error',
                state: {
                  error: {
                    headerKey: 'badPhoto',
                    subHeaderKey: null,
                    ctaButtonKey: 'badPhoto',
                    instrumentationObj: {
                      decisionMsg,
                    },
                  },
                },
              })
            },
            onServiceError: e => {
              showServiceError(e, props.history)
            },
          },
        },
      },
    )
  }

  const renderContent = () => {
    const cancelButtonContent = l10n('dialog.cancelCTA')

    return (
      <div style={{ textAlign: 'center' }}>
        {isLoadingPhoto && (
          <SpinnerContainer>
            <LoadingSpinner screenReaderText="loading" size="lg" />
          </SpinnerContainer>
        )}
        <DialogContent isLoadingPhoto={isLoadingPhoto}>
          <HeadingText size="md">{l10n('dialog.heading')}</HeadingText>
          <BodyText className={`${DialogBodyText}`}>
            {l10n('dialog.paragraph')}
          </BodyText>
          <div style={{ margin: '1.5rem 0' }}>
            <Button
              data-test-id="addPhotoFromDialog"
              className={isMobile ? `${css({ width: '100%' })}` : ''}
              onClick={onAddPhoto}
            >
              {l10n('dialog.continueCTA')}
            </Button>
            <input
              type="file"
              onChange={onFileSelected}
              ref={hiddenFileInput}
              style={{ display: 'none' }}
            />
          </div>
          <div style={{ marginBottom: '3.5rem' }}>
            {isMobile ? (
              <button
                data-test-id="cancelButton"
                className="vx_btn-link"
                onClick={onClose}
              >
                {cancelButtonContent}
              </button>
            ) : (
              <Button
                data-test-id="cancelButton"
                secondary
                onClick={onHandleCancel}
              >
                {cancelButtonContent}
              </Button>
            )}
          </div>
        </DialogContent>
      </div>
    )
  }

  return isMobile ? (
    <Sheet isOpen={isOpen} onClose={onHandleClose}>
      {renderContent()}
    </Sheet>
  ) : (
    <Dialog
      center
      isOpen={isOpen}
      onClose={() => {
        onHandleClose()
      }}
    >
      {renderContent()}
    </Dialog>
  )
}

export default InitialDialog
